import * as React from 'react'
import { SelectSeeker } from 'ui-seeker/core'

const OPTIONS = [
    { label: '0 kids', value: 0 },
    { label: '1 kid', value: 1 },
    { label: '2 kids', value: 2 },
    { label: '3 kids', value: 3 },
    { label: '4 kids', value: 4 },
    { label: '5 kids', value: 5 },
    { label: '6 kids', value: 6 },
    { label: '7 kids', value: 7 },
    { label: '8 kids', value: 8 },
    { label: '9 kids', value: 9 },
    { label: '10 kids', value: 10 },
]

export default function SelectOccupationKids({...props}) {
    const myProps = {
        placeholder: 'Kids occupation',
        firstSelect: true, 
        options: OPTIONS,
        icon: { icon: 'user' },
        isMulti: false,
        ...props
    }

    return <SelectSeeker {...myProps} />
}